import Header from '../components/global/header'
import PrivacyHero from '../components/privacy/privacy-hero'

export default function About() {
    return (
      <>
      <Header />
      <PrivacyHero />
 
      </>
    );
  }